import React, { useEffect, useRef } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getJobApplicationDetails } from "../../../redux/actions/JobActions"
import { CircularProgress, RefreshIcon } from '@material-ui/core';
// import darkblue from '../../../assets/images/bg/dark-blue.jpg';
import { Link, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import 'moment/locale/fr';
import siteService from '../../../services/siteService';
import ApplicationDetailComponent from './ApplicationDetailComponent';

let ApplicationDetail = (props) => {
    const { getJobApplicationDetails } = props;


    const currentSite = siteService.getCurrentSite();
    const [isLoading, setIsLoading] = React.useState(true);
    const [jobApplicationDetails, setJobApplicationDetails] = React.useState(null);

    useEffect(() => {
        let match = props.match;
        if (match !== undefined) {
            let params = match.params;
            if (params !== undefined && params.id !== undefined) {
                getJobApplicationDetails(params.id).then(response => {
                    setJobApplicationDetails(response);
                    setIsLoading(false);
                });
            }
        };
    }, []);



    return (
        <>
            <React.Fragment>
                <Helmet>
                    <title> Administration | Offres d'emploi  | {currentSite.fullName}</title>
                </Helmet>
                {isLoading ? (
                    <div className="row bg-white pt-4 mt-lg-0">
                        <div className="col-lg-12">
                            <div className="loading-container bg-white">
                                <CircularProgress />
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <ApplicationDetailComponent jobApplicationDetails={jobApplicationDetails} />
                    </>
                )}
            </React.Fragment>
        </>
    );
}
ApplicationDetail.propTypes = {
    getJobApplicationDetails: PropTypes.func.isRequired,
    storeJob: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    getJobApplicationDetails: PropTypes.func.isRequired,
    storeJob: state.job,
});

export default withRouter(connect(mapStateToProps, { getJobApplicationDetails })(ApplicationDetail));